import {
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
} from 'reactstrap';

import classnames from 'classnames';
import { useState } from 'react';
import DetailsTab from './DetailsTab/DetailsTab';
import ImageTab from './ImageTab';
import BundleTab from './BundleTab';
import WebsiteTab from './WebsiteTab';
import DescriptionTab from './DescriptionTab';
import { PriceTabContainer } from './PriceTab/PriceTabContainer';
import BinLocationTab from './BinLocationTab';
import WarehouseTab from './WarehouseTab/WarehouseTab';
import ExtendedDetailsTab from './ExtendedDetailsTab';
import AttributeTab from './AttributeTab';

const Submenu = ({ setIsDetailsTab }: { setIsDetailsTab: (isDetailsTab: boolean) => void }) => {
  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsDetailsTab(tab === '1');
    }
  };

  const tabs = [
    {
      id: '1',
      name: 'Details',
    },
    {
      id: '2',
      name: 'Description',
    },
    {
      id: '3',
      name: 'Price',
    },
    {
      id: '4',
      name: 'Bin Location',
    },
    {
      id: '5',
      name: 'Warehouse',
    },
    {
      id: '6',
      name: 'Image',
    },
    {
      id: '7',
      name: 'Bundle',
    },
    {
      id: '8',
      name: 'Website',
    },
    {
      id: '9',
      name: 'Attribute',
    },
    {
      id: '10',
      name: 'Extended Details',
    },
  ];

  return (
    <div>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardBody>
              <Nav pills className="nav nav-tabs-custom arrow-navtabs nav-success  mb-3">
                {tabs.map((tab) => (
                  <NavItem key={tab.id}>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({ active: activeTab === tab.id })}
                      onClick={() => toggleTab(tab.id)}
                    >
                      {tab.name}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className="text-muted">
                <TabPane tabId="1" id="arrow-overview">
                  <DetailsTab />
                </TabPane>
                <TabPane tabId="2" id="arrow-description">
                  <DescriptionTab />
                </TabPane>
                <TabPane tabId="3" id="arrow-price">
                  <PriceTabContainer isActive={activeTab === '3'} />
                </TabPane>
                <TabPane tabId="4" id="arrow-bin-location">
                  <BinLocationTab />
                </TabPane>
                <TabPane tabId="5" id="arrow-warehouse">
                  <WarehouseTab isActive={activeTab === '5'} />
                </TabPane>
                <TabPane tabId="6" id="arrow-image">
                  <ImageTab isActive={activeTab === '6'} />
                </TabPane>
                <TabPane tabId="7" id="arrow-bundle">
                  <BundleTab isActive={activeTab === '7'} />
                </TabPane>
                <TabPane tabId="8" id="arrow-website">
                  <WebsiteTab isActive={activeTab === '8'} />
                </TabPane>
                <TabPane tabId="9" id="arrow-attribute">
                  <AttributeTab />
                </TabPane>
                <TabPane tabId="10" id="arrow-extended-details">
                  <ExtendedDetailsTab />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Submenu;
